<template>
  <BravadoText variant="subhead-semibold" class="war-room-referral-link" @click.native="copyLink">
    <IconLink class="war-room-referral-link__icon" />
    <span class="war-room-referral-link__link" data-test="referral-link">{{ url }}</span>
  </BravadoText>
</template>

<script>
import BravadoText from '~/components/common/BravadoText/BravadoText';

export default {
  name: 'WarRoomReferralLink',
  components: {
    BravadoText,
    IconLink: () => import('@/components/Icon/Link.vue'),
  },
  props: {
    url: {
      type: String,
      default: '',
      required: true,
    },
  },
  methods: {
    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.url);
        this.$notice.success('The link has been copied to clipboard');
      } catch (e) {
        this.$notice.error('The link has not been copied to clipboard', e);
        this.$sentryUtils.error(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.war-room-referral-link {
  display: flex;
  align-items: center;
  color: var(--theme-color-text);
  cursor: pointer;

  &__icon {
    color: var(--gray-50);
    margin-right: 9px;
    transition: color 0.3s;

    &:hover {
      color: var(--gray-35);
    }
  }

  &__link {
    @include text-overflow;

    width: 194px;
  }
}
</style>
